import axios from 'axios';
import { loadEntity } from '@/helpers/utility';

const state = {
    byId: {},
};

const actions = {
    async getVendorInventoryItem(context, { id }) {
        let response = await axios.get(`/api/vendorinventoryitems/${id}`);
        return loadEntity({ vendorInventoryItem: response.data.data });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { vendorInventoryItems }) {
        if (vendorInventoryItems)
            Object.values(vendorInventoryItems).forEach(vendorInventoryItem => Vue.set(state.byId, vendorInventoryItem.id, vendorInventoryItem));
    },
};

export default {
    state,
    actions,
    mutations,
};
